export default __webpack_public_path__ + "static/pe-9412c8bf3459213d3b45844e0e0d5ce9.svg";